import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Resume from '../components/Resume';
import Services from '../components/Services';
import Skills from '../components/Skills';
import Projects from '../components/Projects';
import Contact from '../components/Contact';

const Home = () => {
    return (
        <>
            <Hero />
            <About />
            <Resume />
            <Services />
            <Skills />
            <Projects />
            <Contact />
        </>
    );
};

export default Home;
